'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.getTracker = getTracker, exports.trackPageview = trackPageview, exports.trackEvent = trackEvent, exports.initialize = initialize;
/**
* React Bing Tracking Module
*
* @package react-tracking-bing
* @author Alexander Barge <alexander.barge@gmail.com>
*/

function getTracker() {
  return window.uetq || [];
}

function trackPageview() {
  try {
    getTracker().push('pageLoad');
  } catch (a) {
    // eslint-disable-next-line no-console
    console.warn(a);
  }
}

function trackEvent() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : '',
      b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : '',
      c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : '',
      d = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : 0;

  try {
    getTracker().push('event', a, {
      event_category: b,
      event_label: c,
      event_value: parseInt(d, 10)
    });
  } catch (a) {
    // eslint-disable-next-line no-console
    console.warn(a);
  }
}

function initialize(a) {
  try {
    /* eslint-disable */
    (function (b, c, d, e, g) {
      var h, j, k;
      b[g] = b[g] || [], h = function h() {
        var c = {
          ti: a
        };
        c.q = b[g], b[g] = new UET(c), b[g].push('pageLoad');
      }, j = c.createElement(d), j.src = e, j.async = 1, j.onload = j.onreadystatechange = function () {
        var a = this.readyState;
        a && 'loaded' !== a && 'complete' !== a || (h(), j.onload = j.onreadystatechange = null);
      }, k = c.getElementsByTagName(d)[0], k.parentNode.insertBefore(j, k);
    })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
  } catch (a) {
    // eslint-disable-next-line no-console
    console.warn(a);
  }
}

exports.default = {
  initialize: initialize,
  getTracker: getTracker,
  trackPageview: trackPageview,
  trackEvent: trackEvent
};